import ConnectPaymentModal from './ConnectPaymentModal';
export default ConnectPaymentModal;
